export default class Actions {
    scrollUp() {
        $('.btn-up').click(function(e) {
          e.preventDefault();

          $('html, body').animate({
            scrollTop: 0
          }, 500);
        });
    }

    scrollToAnchor() {
      $(document).on('click', 'a[href^="#"]', function (e) {
        e.preventDefault();
        if ($.attr(this, 'href') != '#') {

          document.body.classList.remove('nav-toggled');

          $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
          }, 500);
        }
      });
    }

    navToggler() {
      let toggler = document.querySelector('.btn-nav');
      toggler.addEventListener('click', () => {
        document.body.classList.toggle('nav-toggled')
      });

      // $('.menu-item-has-children span').click(function(e) {
      //   e.preventDefault();
      //   $(this).parent().find('.submenu').toggleClass('active');
      // });
    }


    video() {
      $('.box-video button').click(function(e) {
        var $box = $(this).parents('.box-video');
        e.preventDefault();

        $box.find('.box-video__poster').hide();
        $box.find('video').trigger('play');
      })
    }

    tabs() {
      $('.tab-menu__btn').click(function() {
        var index = $(this).index();

        $('.tab-menu__btn').removeClass('active');
        $(this).addClass('active');

        $('.tab-box__item').removeClass('active');
        $('.tab-box__item').eq(index).addClass('active');
      });
    }

    faq() {
      $('.faq-box__header').click(function() {
        $(this).parent().toggleClass('active');
      });
    }
  
    init() {
      document.querySelector('.btn-up') ? this.scrollUp() : null;
      document.querySelector('.btn-nav') ? this.navToggler() : null;
      document.querySelector('.tab-box') ? this.tabs() : null;
      document.querySelector('.faq-list') ? this.faq() : null;
      this.scrollToAnchor();
    }
}
